module.exports = __webpack_public_path__ + "static/media/sound_icon.86e95fba.webp";